import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const API_URL = process.env.REACT_APP_API_URL;

export const fetchMyProperties = createAsyncThunk(
  "myProperties/fetchMyProperties",
  async ({ id, token }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_URL}/api/v1/property/search?agent_id=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        const responseDataError = await response.json();
        const errorMessage = responseDataError.error || "Произошла ошибка";
        return rejectWithValue(errorMessage);
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const myPropertiesSlice = createSlice({
  name: "myProperties",
  initialState: {
    myProperties: [],
    status: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyProperties.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchMyProperties.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.myProperties = action.payload;
      })
      .addCase(fetchMyProperties.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default myPropertiesSlice.reducer;
